import { render, staticRenderFns } from "./cardsTradeList.vue?vue&type=template&id=7c13f19c&scoped=true&"
import script from "./cardsTradeList.vue?vue&type=script&lang=js&"
export * from "./cardsTradeList.vue?vue&type=script&lang=js&"
import style0 from "./cardsTradeList.vue?vue&type=style&index=0&id=7c13f19c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c13f19c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VContainer})
